import type { Message } from '../../api/types'
import { Icon } from '../../components/Icon'
import { userName } from '../../lib/channels'
import { describeClip, firstClip } from '../../lib/media'
import { useConversation } from './ConversationContext'

/** A message in a quote, the pinned list or a sheet: its words, else its first clip ("🎤 Voice message (0:42)") or file. */
export function replySummary(message: Pick<Message, 'body' | 'attachments' | 'deletedAt'>): string {
  if (message.deletedAt) return 'Message deleted'
  if (message.body) return message.body
  const clip = firstClip(message.attachments)
  if (clip) return describeClip(clip) ?? clip.fileName
  const first = message.attachments[0]
  return first ? `Attachment: ${first.fileName}` : 'Message'
}

export function ReplyQuote({ replyToId }: { replyToId: string }) {
  const { messagesById, users, me, jumpToMessage } = useConversation()
  const original = messagesById.get(replyToId)
  const author = original ? (original.authorId === me.id ? 'You' : userName(users, original.authorId)) : 'Earlier message'
  const text = original ? replySummary(original) : 'Tap to load the original message'
  return (
    <button
      type="button"
      className="reply-quote"
      aria-label={`Reply to ${author}: ${text}. Go to the original message`}
      onClick={() => jumpToMessage(replyToId, original?.seq)}
    >
      <strong>
        <Icon name="reply" />
        {author}
      </strong>
      <span>{text}</span>
    </button>
  )
}
